module.exports = __webpack_public_path__ + "img/avatar.bc7f1fc9.png";